// extracted by mini-css-extract-plugin
export var image = "product-details-module--image--BD80E";
export var compatibility = "product-details-module--compatibility--m44ci";
export var description = "product-details-module--description--5nQCl";